module.exports = __webpack_public_path__ + "static/media/People.9a40588e.jpg";